var _rect, _rect2, _rect3, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 293,
    viewBox: "0 0 293 293",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 24.7262,
    y: 24.726,
    width: 243.548,
    height: 243.548,
    rx: 121.774,
    fill: "white",
    stroke: "#D06060",
    strokeWidth: 14
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 7,
    y: 7,
    width: 279,
    height: 279,
    rx: 139.5,
    stroke: "#D06060",
    strokeWidth: 14
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35.4523,
    y: 35.4519,
    width: 222.096,
    height: 222.096,
    rx: 111.048,
    fill: "#D06060"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.453 101V155.809",
    stroke: "white",
    strokeWidth: 11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.577 185.462C148.577 186.864 147.44 188 146.038 188C144.637 188 143.5 186.864 143.5 185.462C143.5 184.06 144.637 182.923 146.038 182.923C147.44 182.923 148.577 184.06 148.577 185.462Z",
    stroke: "white",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorVector);
export default __webpack_public_path__ + "static/media/error_vector.5e3a6e633d69bbd8195ec1c9fd0cfc54.svg";
export { ForwardRef as ReactComponent };